import { render } from "./IBoard.vue?vue&type=template&id=26a1b79c"
import script from "./IBoard.vue?vue&type=script&lang=js"
export * from "./IBoard.vue?vue&type=script&lang=js"

import "./IBoard.vue?vue&type=style&index=0&id=26a1b79c&lang=scss"
script.render = render

export default script